<template>
  <div>
    <div class="px-6 md:px-10 lg:px-40 pt-10 pb-6 text-center">
      <h1
        class="text-3xl sm:text-4xl md:text-5xl font-extrabold text-[#3DCBB1] tracking-tight"
      >
        {{ $t("daily.title") }}
      </h1>
      <p class="text-gray-400 text-sm mt-2">
        {{ $t("daily.subtitle") }}
      </p>
    </div>

    <section
      v-if="blogs.length"
      class="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 px-6 md:px-10 lg:px-40 py-10"
    >
      <div
        v-for="blog in blogs"
        :key="blog.id"
        class="relative rounded-[20px] overflow-hidden group shadow-lg"
      >
        <NuxtLink :to="`/daily-blog/${blog.id}`">
          <img
            v-if="blog.thumbnail"
            :src="blog.thumbnail"
            :alt="blog.title"
            class="w-full h-[250px] object-cover transition duration-300 group-hover:scale-105"
          />
          <div class="p-4">
            <h3 class="text-xl font-semibold hover:underline">
              {{ blog.title }}
            </h3>
            <p class="text-sm text-gray-500 mt-1">
              {{ formatDate(blog.created_at) }}
            </p>
            <div class="mt-3" v-html="getSummary(blog.content)" />
            <NuxtLink
              :to="`/daily-blog/${blog.id}`"
              class="inline-block mt-4 text-[#3DCBB1] hover:underline font-medium"
            >
              {{ $t("daily.read_more") }} →
            </NuxtLink>
          </div>
        </NuxtLink>
      </div>
    </section>

    <div
      v-else
      class="text-center text-gray-400 py-20 text-xl sm:text-2xl px-6 md:px-10 lg:px-40"
    >
      ✍️ {{ $t("daily.empty_line1") }}<br />
      {{ $t("daily.empty_line2") }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useSupabaseClient, useI18n } from "#imports";

const { locale } = useI18n();

interface Blog {
  id: number;
  title: string;
  content: string;
  created_at: string;
  thumbnail: string | null;
}

const blogs = ref<Blog[]>([]);
const supabase = useSupabaseClient();

onMounted(async () => {
  const { data, error } = await supabase
    .from("blogs")
    .select("*")
    .order("created_at", { ascending: false });

  if (error) {
    console.error("Blog verileri alınamadı:", error.message);
    return;
  }

  blogs.value = data || [];
});

const formatDate = (dateStr: string): string => {
  const d = new Date(dateStr);
  return d.toLocaleDateString(locale.value === "en" ? "en-US" : "tr-TR", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

const getSummary = (html: string, maxLength = 120) => {
  const temp = document.createElement("div");
  temp.innerHTML = html;
  const text = temp.textContent || temp.innerText || "";
  return text.slice(0, maxLength) + "...";
};
</script>

<style scoped>
/* Tailwind kullanıldığı için ekstra stil gerekmez */
</style>
